import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GeofencesService } from './Geofences.service';

@Injectable({
  providedIn: 'root'
})
export class PanelGeofencesService {
  public Result;
  private isLoading$: Subject<boolean> = new Subject();
  isVisiblePanel$: Subject<boolean> = new Subject<boolean>();

  constructor(private geofenceService: GeofencesService) {
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  findByIdentifier(identifier): any {
    return this.geofenceService.findByIdentifier(identifier);
  }

  getList(): any {
    return this.geofenceService.getList();
  }

}
